import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { get } from 'lodash'
import { FileUpload, FileLink } from 'containers/misc'
import { Section, Span, Title } from 'components/layout'
import { setPage, logError, notification } from 'redux/modules/app'
import { onDataImport } from 'redux/modules/api/data-import'
import { compose } from 'recompose'
import styles from '../ChangeAwardMode/change-award-mode.styl'
import { Module, Row } from '../../../../components/misc'
import ConfigurationFile from '../../../misc/ConfigurationFile/ConfigurationFile'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'

const enhance = compose(
  injectIntl,
  connect(
    ({ api }) => ({
      blobs: api.blobs,
      dataImport: api.dataImport
    }),
    { setPage, onDataImport, logError, notification }
  )
)
class ImportOfflineParticipants extends Component {
  static propTypes = {
    blobs: PropTypes.object,
    dataImport: PropTypes.object,
    onDataImport: PropTypes.func.isRequired,
    notification: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    logError: PropTypes.func,
    setPage: PropTypes.func
  }

  state = {
    loadingInfo: this.props.intl.formatMessage({
      id: 'label.preparing_document_for_import',
      defaultMessage: 'Preparing document for import'
    }),
    reset: false,
    errorFileUrl: null
  }

  handleOnBlobUpdate = ({ url } = {}) => {
    this.setState(
      {
        loadingInfo: this.props.intl.formatMessage({
          id: 'label.importing_file',
          defaultMessage: 'Importing file'
        }),
        reset: false
      },
      () => {
        this.props
          .onDataImport({
            value: url
          })
          .then(() => {
            this.props.notification(
              'Spreadsheet has been imported successfully',
              {
                intlKey:
                  'notifications.spreadsheet_has_been_imported_successfully'
              }
            )
            this.setState({
              ...this.state,
              reset: true
            })
          })
          .catch(err => {
            if (get(err, 'body.url')) {
              this.setState({
                ...this.state,
                reset: true,
                errorFileUrl: err.body.url
              })
            }

            this.props.logError(err)
          })
      }
    )
  }

  render() {
    const { dataImport } = this.props
    const { loadingInfo, reset, errorFileUrl } = this.state

    return (
      <div className={styles.module_wrapper}>
        <Module verticallyNarrow primary>
          <div className={styles.wrapper}>
            <Row alignItems="center" gutters inner paddingTop>
              <Title h1>
                <FormattedMessage
                  id="moduleTitle.offline_participants_import"
                  defaultMessage="Import Offline Participants"
                />
              </Title>
            </Row>
            <Row alignItems="center" gutters inner paddingTop>
              <Section
                loading={dataImport.offlineImportLoading}
                loadingDescription={loadingInfo}
              >
                <div className="base-margin--bottom">
                  <Span intlKey="moduleTitle.offline_participants_import.description">
                    Participants will be imported as „in progress“ offline and they will receive an email
                  </Span>
                </div>
                <div className="base-margin--bottom">
                  <FileUpload
                    onUploadComplete={this.handleOnBlobUpdate}
                    actionIntlKey="button.import_data_from_selected_file"
                    actionText="Import data from selected file"
                    autoupload={false}
                    resetFile={reset}
                  />
                </div>
                <div className="base-margin--bottom">
                  <ConfigurationFile
                    configKey={CONFIGURATION_KEYS.offlineParticipantsImportTemplate.id}
                    isPublic
                    formattedName={
                      <FormattedMessage
                        id="label.offlineParticipantsImportTemplate"
                        defaultMessage="Offline participants import template"
                      />
                    }
                  />
                </div>
                {errorFileUrl && (
                  <div className="base-margin--bottom">
                    <Span
                      error
                      intlKey="errors.a_problem_has_occured_during_processing"
                    >
                      A problem has occured during processing, see more information
                    </Span>{' '}
                    <FileLink src={errorFileUrl} intlKey="label.here" label="here"/>.
                  </div>
                )}
              </Section>
            </Row>
          </div>
        </Module>
      </div>
  )
  }
}

export default enhance(ImportOfflineParticipants)
